import { InfoEventName } from '../events';
import { reportTelemetryEvent } from '../report';
import { AnalyticsV2EventProps, createAnalyticsV2Event } from '../report/protobuf/createAnalyticsV2Event';

import { reportInfo } from './info';

interface ReportUsageOptions extends AnalyticsV2EventProps {
  readonly loggingOptions?: {
    readonly eventName: string;
    readonly shouldReportErrors: boolean;
  };
}

export type ReportUsage = (options: ReportUsageOptions) => void;
export const reportUsageV2: ReportUsage = async ({ loggingOptions, ...analyticsOptions }) => {
  try {
    const analyticsV2Event = await createAnalyticsV2Event(analyticsOptions);

    reportTelemetryEvent(analyticsV2Event);
  } catch (err) {
    if (loggingOptions?.shouldReportErrors) {
      reportInfo({
        eventName: InfoEventName.AnalyticsV2EventErrored,
        eventProperties: {
          errorMessage: (err as Error).message,
          name: loggingOptions.eventName,
        },
      });
    }
  }
};
